import { render, staticRenderFns } from "./ThirdStrategy.vue?vue&type=template&id=31bf2a68&scoped=true"
import script from "./ThirdStrategy.vue?vue&type=script&lang=js"
export * from "./ThirdStrategy.vue?vue&type=script&lang=js"
import style0 from "./ThirdStrategy.vue?vue&type=style&index=0&id=31bf2a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bf2a68",
  null
  
)

export default component.exports